import { render, staticRenderFns } from "./VTip.vue?vue&type=template&id=6b096d31&"
import script from "./VTip.vue?vue&type=script&lang=ts&"
export * from "./VTip.vue?vue&type=script&lang=ts&"
import style0 from "./VTip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports